import type { RendererProps } from "../core/element-registry"
import { cn } from "../lib/utils"

/**
 * Inline donut ring progress indicator (16px default).
 * Matches shadcn/ui v4 usage-card pattern.
 *
 * Props on element:
 *   value: 0-100 percentage (number or string)
 *   size:  pixel size (default 16)
 *   className: Tailwind utility classes (color via text-*, etc.)
 */
export function RingProgressRenderer({ element }: RendererProps) {
  const rawValue = (element as any).value
  const value = Math.max(
    0,
    Math.min(100, typeof rawValue === "number" ? rawValue : Number(rawValue ?? 0)),
  )
  const size = (element as any).size ?? 16
  const r = 42.5
  const circumference = 2 * Math.PI * r
  const offset = circumference * (1 - value / 100)

  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={size}
      width={size}
      strokeWidth={2}
      viewBox="0 0 100 100"
      className={cn("-rotate-90", element.className)}
    >
      <circle
        cx={50}
        cy={50}
        r={r}
        strokeWidth={12}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="opacity-20"
        stroke="currentColor"
        style={{ strokeDasharray: `${circumference}, ${circumference}` }}
      />
      <circle
        cx={50}
        cy={50}
        r={r}
        strokeWidth={12}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
        style={{
          strokeDasharray: `${circumference}, ${circumference}`,
          strokeDashoffset: offset,
        }}
      />
    </svg>
  )
}
